import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
export default function Icon(_ref) {
  var _htmlAttrs$ariaHidde;
  let {
    spin,
    strokeColor,
    size = '1em',
    contextType = 'image',
    widthRatio = 1,
    ...htmlAttrs
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({}, htmlAttrs, {
    "aria-hidden": (_htmlAttrs$ariaHidde = htmlAttrs['aria-hidden']) !== null && _htmlAttrs$ariaHidde !== void 0 ? _htmlAttrs$ariaHidde : true,
    color: htmlAttrs.color || 'inherit',
    preserveAspectRatio: htmlAttrs.preserveAspectRatio || 'xMidYMid meet',
    spin: spin,
    strokeColor: strokeColor,
    size: size,
    contextType: contextType,
    width: `${widthRatio * parseInt(size.toString())}em`
  }));
}
const getRotate360 = contextType => {
  return keyframes(["from{transform:", "rotate(0deg);}to{transform:", "rotate(360deg);}"], contextType === 'text' && 'translateY(.125em) ', contextType === 'text' && 'translateY(.125em) ');
};
const getTransform = _ref2 => {
  let {
    rotate,
    contextType
  } = _ref2;
  const array = [contextType === 'text' && 'translateY(.125em)', rotate && `rotate(${parseInt(rotate.toString())}deg)`, ';'].filter(v => v);
  return array.length > 1 ? `transform: ${array.join(' ')}` : '';
};
export const StyledIcon = /*#__PURE__*/styled.svg.withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "sc-1prjaow-0"
})(["display:inline-block;fill:currentColor;user-select:none;height:1em;transition:transform .3s ease-in-out;font-size:", ";", " ", " path,circle,rect,polygon{", " ", "}"], _ref3 => {
  let {
    size = '1em'
  } = _ref3;
  return size;
}, _ref4 => {
  let {
    contextType,
    spin
  } = _ref4;
  return spin && css(["animation:", " ", " linear;animation-iteration-count:infinite;"], getRotate360(contextType), typeof spin === 'boolean' ? '1.5s' : spin);
}, _ref5 => {
  let {
    rotate,
    contextType
  } = _ref5;
  return getTransform({
    rotate,
    contextType
  });
}, _ref6 => {
  let {
    strokeWidth
  } = _ref6;
  return strokeWidth && `stroke-width: ${strokeWidth};`;
}, _ref7 => {
  let {
    strokeColor
  } = _ref7;
  return strokeColor && `stroke: ${strokeColor};`;
});